import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import "./flaggreasonForm.scss";
import { Question, saveQuestionReview } from "../../../models/ComplianeQuestionarie";
import SpinnerModel from "../../../commonfields/SpinnerModel";
import { TextField } from "common-fields";
import { normalizeTextarea } from "dynamic-questionarie";
import validate from "./validate";


interface QuestionnarieFormProps {
  formValues: any;
  currentQuestions: Array<Question>;
  disableFields: boolean;
  formInitialvalues: any;
  reviewValues: any;
  postsavequestion: (body: saveQuestionReview) => void;
  isEditReason: boolean;
}

const FlaggReasonForm: React.FC<
  QuestionnarieFormProps & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const [loader, setLoader] = useState(false);
  const submitFlag = (question: Question) => {
  setLoader(true);
    if (props?.complianceStatusData?.status !== "REVIEW_COMPLETED") {
      let body:saveQuestionReview={
        accepted: question.reviewAccepted,
        flagged: props?.isEditReason
          ? question.reviewFlagged
          : !question.reviewFlagged,
        items: [],
        notes: question.reviewNotes,
        infoId: props.infoId,
        flaggedReason:question.flaggedReason,
        naReason: question.naReason,
        naFlag:true
      };
      if(props.button==="Flag" || props.button==="Confirm"){
        body = {
          accepted: question.reviewAccepted,
          flagged: props?.isEditReason
          ? question.reviewFlagged
          : !question.reviewFlagged,
          items: [],
          notes: question.reviewNotes,
          infoId: props.infoId,
          flaggedReason: props.formValues.flaggedReason,
          naReason:props.formValues?.naReason,
          naFlag: props.button === "Flag" ? question.naFlag : true,
        };
      }
          
      if (question.complianceGroupId) {
        props.currentQuestions
          .filter(
            (m: Question) =>
              m.complianceGroupId == question.complianceGroupId &&
              m.serialNumber == question.serialNumber
          )
          .map(
            (m: Question) =>
              (body.items = [
                ...body?.items,
                {
                  clientQuestionId: m.clientQuestionId,
                  reviewClientQuestionId: m.reviewClientQuestionId,
                },
              ])
          );
      } else {
        body.items = [
          {
            clientQuestionId: question.clientQuestionId,
            reviewClientQuestionId: question.reviewClientQuestionId,
          },
        ];
      }
      props.postsavequestion(body);
      setLoader(false);
      props.flagModalViewHandler();
    }
  };

  return (
    <div className="reasonForFlagForm">
    
      {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : null}
      <Field
        component={TextField}
        label={props.label}
        type="textarea"
        name={"flaggedReason"}
        HelpText={"flaggedReason"}
        isRequired="true"
        normalize={normalizeTextarea}
      />
      <div className="btnFlag">
        <Button
          className={
            !(
              props?.formValues?.flaggedReason &&
              props?.formValues?.flaggedReason.length >= 10
            )
              ? "flagBtnDisable"
              : "flagBtn"
          }
          onClick={() => submitFlag(props.flaggedQuestion)}
          disabled={
            !(
              props?.formValues?.flaggedReason &&
              props?.formValues?.flaggedReason.length >= 10
            )
          }
        >
         {props.button}
        </Button>
      </div>
    </div>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: {
      flaggedReason: props?.flaggedReason
        ? props?.flaggedReason
        : props?.flaggedQuestion?.flaggedReason,
      naReason: props?.naReason
      ? props?.naReason
      : props?.naQuestion?.naReason,
    },
    formValues: getFormValues("FlaggReasonForm")(state),
  };
})(
  reduxForm<Record<string, unknown>, any>({
    form: "FlaggReasonForm",
    enableReinitialize: true,
    validate,
  })(FlaggReasonForm)
);
